export default "__VITE_ASSET__DOxZK$gx__"